// extracted by mini-css-extract-plugin
export var container = "_8c-0";
export var fallback = "_8c-5";
export var fallbackIcon = "_8c-6";
export var hidden = "_8c-2";
export var image = "_8c-3";
export var loaded = "_8c-4";
export var placeholder = "_8c-1";